const GOPAY = 'gopay';

export default {
	GOPAY,
}


// WEBPACK FOOTER //
// ./src/enums/PaymentGateway.js